import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs';
import {QuickQuote} from "@data/schema/ratequote/quick-quote";
import {QuickQuoteResults} from "@data/schema/ratequote/quick-quote-results";
import {QuickQuoteResultsRoot} from "@data/schema/ratequote/quick-quote-results-root";
import {InviteBorrower} from "@data/schema/ratequote/invite-borrower";
import {transaction} from "@data/schema/ratequote/quote-constants";




@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private quickQuote: BehaviorSubject<QuickQuote>;
  private quickQuoteResults: BehaviorSubject<QuickQuoteResults>;
  private quickQuoteResultsRoot: BehaviorSubject<QuickQuoteResultsRoot>;
  private newLoanResponse: BehaviorSubject<InviteBorrower>;
  private selectedRateGridId : string;
  private selectedCriteriaKey : string;

  private progress_percentage: number ;
  private invitationResponse: InviteBorrower;
  globalQQ: QuickQuote;

  constructor() {
    this.quickQuote = new BehaviorSubject<QuickQuote>(
      JSON.parse(localStorage.getItem('quickQuote'))
    );
    this.quickQuoteResults = new BehaviorSubject<QuickQuoteResults>(
      JSON.parse(localStorage.getItem('quickQuoteResults'))
    );
    this.quickQuoteResultsRoot = new BehaviorSubject<QuickQuoteResultsRoot>(
      JSON.parse(localStorage.getItem('quickQuoteResultsRoot'))
    );
    this.newLoanResponse = new BehaviorSubject<InviteBorrower>(
      JSON.parse(localStorage.getItem('newLoanResponse'))
    );
     this.selectedRateGridId =  JSON.parse(localStorage.getItem('selectedRateGridId'));
    this.selectedCriteriaKey =  JSON.parse(localStorage.getItem('selectedCriteriaKey'));
    this.progress_percentage = JSON.parse(localStorage.getItem('progress_percentage'));


  }
  setProgressPercentage(progressPercent: number) {
    localStorage.setItem('progress_percentage', JSON.stringify(progressPercent));
  }
  getProgressPercentage() {
    return JSON.parse(localStorage.getItem('progress_percentage'));
  }


  setQuickQuote(quickQuote: QuickQuote) {
    this.quickQuote.next(quickQuote);
    localStorage.setItem('quickQuote', JSON.stringify(this.quickQuote.value));
  }

  getQuickQuote(): Observable<QuickQuote> {
    if (JSON.parse(localStorage.getItem('quickQuote')) == null) {
      this.quickQuote = new BehaviorSubject<QuickQuote>(new QuickQuote());
    }
    return this.quickQuote;
  }

  setQuickQuoteResults(quickQuoteResults: QuickQuoteResults) {
    this.quickQuoteResults.next(quickQuoteResults);
    localStorage.setItem(
      'quickQuoteResults',
      JSON.stringify(this.quickQuoteResults.value)
    );
  }
  clearQuickQuoteStorage() {
    localStorage.removeItem('quickQuote');
    localStorage.removeItem('quickQuoteResultsRoot');
    localStorage.removeItem('newLoanResponse');
    localStorage.removeItem('quickQuoteResults');
  }

  setNewLoanResponse(newLoanResponse: InviteBorrower) {
    this.newLoanResponse.next(newLoanResponse);
    localStorage.setItem(
      'newLoanResponse',
      JSON.stringify(this.newLoanResponse.value)
    );
  }


  isMIMandatory(): boolean {
    this.getQuickQuote().subscribe(quickQuote => {
      this.globalQQ = quickQuote;
    });
    if (
      (this.globalQQ.transactionType === transaction.PURCHASE &&
        (this.globalQQ.govtLoan || this.globalQQ.loanToValue <= 80)) ||
      (this.globalQQ.loanToValue <= 80 &&
        (this.globalQQ.transactionType === transaction.REFINANCE ||
          this.globalQQ.transactionType === transaction.REFINANCE_CASH_OUT))
    ) {
      return false;
    } else return true;
  }
  isTaxAndEscrowsMandatory(): boolean {
    this.getQuickQuote().subscribe(quickQuote => {
      this.globalQQ = quickQuote;
    });
    if (this.globalQQ.loanToValue <= 80) {
      return true;
    } else return false;
  }
}
